import { settings } from './settings';

// eslint-disable-next-line
export default {
  oidc: {
    clientId: settings.okta.OKTA_CLIENT_ID!,
    issuer: settings.okta.OKTA_ISSUER!,
    redirectUri: settings.APP_ORIGINAL_URI + '/login/callback',

    scopes: ['openid', 'profile', 'email', 'groups'],
    pkce: true,
    disableHttpsCheck: settings.okta.OKTA_TESTING_DISABLEHTTPSCHECK || false,
  },
};
